// src/components/ImageGallery/ImageCategoryCard.js

import React from 'react';
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import Card from '@mui/material/Card'; 
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import swal from 'sweetalert';

const API_BASE_URL = "https://test-api.stainedglassusa.com";

export default function ImageCategoryCard({ image }) {
    const history = useHistory();
    const dispatch = useDispatch();
    
    // NATIVE FIX: Pull both the true application token and user object directly from Redux
    const { user, token } = useSelector(state => state.auth);

    const handleCategorySelect = () => {
        if (!window.wp_user) {
            swal("Login Required", "You must be logged in to color windows.", "warning")
            .then(() => {
                window.location.href = "/wp-login.php?redirect_to=" + window.location.href;
            });
            return; 
        }

        // 1. APP USER REQUIREMENT: Check if the background handshake has fetched the real Ruby user data yet
        if (!user || !user.id || !token || token === 'wordpress_session') {
            swal("Initializing Session", "Please wait a second while your design studio initializes...", "info");
            return;
        }
        
        // 2. NATIVE RECORD LAYOUT: Tie the canvas instance directly to the authentic Ruby user.id
        let newImage = { 
            image_id: image.id, 
            user_id: user.id 
        };

        console.log(`[Card Action] Dispatching standard image creation request for Ruby User ID: ${user.id}`);

        // 3. SECURE TRANSPORT: Send the request using the authentic Ruby application token
        fetch(`${API_BASE_URL}/user_images`, {
            method: 'POST',
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `bearer ${token}`
            },
            body: JSON.stringify(newImage)
        })
        .then(r => r.json())
        .then((resp) => {
            if (!resp || !resp.id) {
                console.error("API responded but user_image ID is missing:", resp);
                return;
            }

            dispatch({
                type: 'ADD_USER_IMAGE',
                payload: resp
            });
            
            history.push(`/coloringpage/${resp.id}`);    
        })
        .catch(err => {
            console.error("Failed to generate user canvas image instance:", err);
        });
    };

    const getImageUrl = (svgUrl) => {
        if (!svgUrl) return null;
        if (svgUrl.startsWith('http://') || svgUrl.startsWith('https://')) {
            return svgUrl;
        }
        const path = svgUrl.startsWith('/') ? svgUrl : `/${svgUrl}`;
        return `${API_BASE_URL}${path}`;
    };

    const imageUrl = getImageUrl(image?.svg_url);

    return (
        <Card sx={{ maxWidth: 345, margin: 2, cursor: 'pointer' }} onClick={handleCategorySelect}>
            {imageUrl ? (
                <CardMedia
                    component="img"
                    height="194"
                    image={imageUrl}
                    alt={image?.title || 'Featured Design'}
                    sx={{ objectFit: 'contain', padding: 1, borderBottom: '1px solid #eee' }} 
                />
            ) : (
                <div style={{ height: 194, display: 'flex', alignItems: 'center', justifyContent: 'center', borderBottom: '1px solid #eee' }}>No Preview</div>
            )}
            <CardContent>
                <Typography gutterBottom variant="h6" component="div">
                    {image?.parent_name || 'Featured Designs'}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {image?.title || image?.description || 'View Collection'}
                </Typography>
            </CardContent>
            <CardActions>
                <Button size="small" onClick={handleCategorySelect}>View Collection</Button>
            </CardActions>
        </Card>
    );
}